import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MainContent from "../../layouts/maincontent/MainContent";
import InputElement from "../../shared/form/InputElement";
import styleProfile from "../../shared/pages/profile/Profile.module.css";
import { getPaymentData } from "../../adapters/apis/lookups/lookups";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import { get } from "../../adapters/xhr/api";

function DetailsOnlinePayment() {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const online_enquiry_type = location?.state || 1;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified =
         response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getPaymentData(id)
      .then((res) => {
        setData(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 404) {
          navigate("/not-found");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <MainContent>
          <section className={`section-content pt-md-0 pt-4 pb-5`}>
            <div className={`container`}>
              <div className={`card-box`}>
                <div className={`box-content`}>
                  {
                    <div className="btn-myProfile d-flex justify-content-end flex-md-row flex-column gap-lg-5 gap-3  align-items-center mt-3">
                      {
                        <Link
                          to={"/online-payment/pay-online/" + id}
                          className={styleProfile["btn-edit"]}
                          id="pay_for_same_unit"
                        >
                          أدفع لنفس الوحدة
                        </Link>
                      }
                      {
                        <Link
                          to="/online-payment/list-payment"
                          className={styleProfile["btn-edit"]}
                          id="payments_list"
                        >
                          قائمة المدفوعات
                        </Link>
                      }
                    </div>
                  }
                  <div className={`box`}>
                    <h4 className={`box-title mb-4`}>بيانات العقار</h4>
                    {parseInt(online_enquiry_type) === 1 ||
                    parseInt(online_enquiry_type) === 3 ? (
                      <div className="row">
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="المحافظة"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.gov || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="المركز / المأمورية / القسم"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.district || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="الشياخة / الناحية"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.village || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText={
                              parseInt(online_enquiry_type) === 3
                                ? "أسم الشارع"
                                : "أسم الشارع / قرية سياحية"
                            }
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.street || ""}
                            disabled={true}
                          />
                        </div>
                        {parseInt(online_enquiry_type) === 3 && (
                          <div className="col-md-3">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="place"
                              name="place"
                              labelClassName={`form-label`}
                              labelText="القرية"
                              inputType="text"
                              inputClassName={`form-control`}
                              inputID="place"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={data?.place || ""}
                              disabled={true}
                            />
                          </div>
                        )}
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="رقم العقار"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.build || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="رقم الدور"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.part || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="رقم الوحدة"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.unit || ""}
                            disabled={true}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="access_key"
                            labelClassName={`form-label`}
                            labelText="كود حساب الوحدة"
                            inputClassName={`form-control`}
                            inputID="access_key"
                            name="access_key"
                            default="كود حساب الوحدة"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            payment="1"
                            inputType="text"
                            value={data?.acc_key || ""}
                            disabled={true}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={`box`}>
                    <h4 className={`box-title mb-4`}>بيانات مالك العقار </h4>
                    <div className="row">
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="airport_name"
                          name="airport_name"
                          labelClassName={`form-label`}
                          labelText="أسم المالك / المنتفع"
                          inputType="text"
                          inputClassName={`form-control`}
                          inputID="airport_name"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.current_owner || ""}
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="airport_name"
                          name="airport_name"
                          labelClassName={`form-label`}
                          labelText="أسم الشاغل"
                          inputType="text"
                          inputClassName={`form-control`}
                          inputID="airport_name"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.occupant_name || ""}
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="airport_name"
                          name="airport_name"
                          labelClassName={`form-label`}
                          labelText="أسم صاحب التكليف"
                          inputType="text"
                          inputClassName={`form-control`}
                          inputID="airport_name"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.owner_name || ""}
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`box`}>
                    <h4 className={`box-title mb-4`}>
                      بيانات الشخصية لصاحب العقار
                    </h4>
                    <div className="row">
                      <div className="col-md-3">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="airport_name"
                          name="airport_name"
                          labelClassName={`form-label`}
                          labelText="الجنسية"
                          inputType="text"
                          inputClassName={`form-control`}
                          inputID="airport_name"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={
                            data?.nationality === "EG" ? "مصري" : "أجنبي" || ""
                          }
                          disabled="disabled"
                        />
                      </div>
                      {data?.nationality === "EG" && (
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="الرقم القومى"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.national_passport_id || ""}
                            disabled="disabled"
                          />
                        </div>
                      )}
                      {data?.nationality !== "EG" && (
                        <div className="col-md-3">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="airport_name"
                            name="airport_name"
                            labelClassName={`form-label`}
                            labelText="رقم جواز السفر"
                            inputType="text"
                            inputClassName={`form-control`}
                            inputID="airport_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.national_passport_id || ""}
                            disabled="disabled"
                          />
                        </div>
                      )}
                      <div className="col-md-3">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="airport_name"
                          name="airport_name"
                          labelClassName={`form-label`}
                          labelText="رقم الهاتف"
                          inputType="text"
                          inputClassName={`form-control`}
                          inputID="airport_name"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.mobile || ""}
                          disabled="disabled"
                        />
                      </div>
                    </div>
                  </div>
                  {/*<div className="btn-myProfile d-flex justify-content-start flex-md-row flex-column gap-lg-5 gap-3  align-items-center mt-4">
              {  <Link to={'/online-payment/pay-online/'+ id } className={ styleProfile['btn-cancle'] }>أدفع لنفس الوحدة</Link>}
              {  <Link to="/online-payment/list-payment" className={ styleProfile['btn-cancle'] }>قائمة المدفوعات</Link>}
                </div>*/}
                </div>
              </div>
            </div>
          </section>
        </MainContent>
      )}
    </>
  );
}
export default DetailsOnlinePayment;
